// Regla unica Venta/Preventa, espejo del backend (TypeInteraction='conference' OR OperationType='Sales').
// Acepta cualquiera de las tres senales segun la superficie: callKind (tabla), operationType/typeInteraction
// (transcripcion / analisis por-protocolo). Preventa = NO venta.
export const isVentaCall = ({ callKind, operationType, typeInteraction } = {}) =>
  callKind === 'Venta' ||
  operationType === 'Sales' ||
  typeInteraction === 'conference';
